module.exports = __webpack_public_path__ + "img/ek.1a58af3f.jpg";